export default "__VITE_ASSET__B64W9ivO__"